<mat-card>
  <app-card-header
    icono="storefront"
    [title]="title || ''"
    [draggable]="true"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
    [cdkDragBoundary]="dragBoundary"
    [cdkDragDisabled]="loading || !dragBoundary"
    cdkDrag
    cdkDragHandle
    cdkDragRootElement=".cdk-overlay-pane"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form id="form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-card-content class="card-content-crear">
        <!-- Datos Básicos -->
        <app-content-card title="Datos del proveedor" icon="assignment">
          <!-- Cliente -->
          @if (!helper.esClienteFinal()) {
            <section class="inputs-group">
              <app-cliente-selector
                formControlName="idCliente"
                style="width: 100%"
              ></app-cliente-selector>
            </section>
          }

          <!-- Nombre y tipos -->
          <section class="inputs-group">
            <mat-form-field style="flex: 1; min-width: 0">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombre" />
              <mat-icon matPrefix>storefront</mat-icon>
            </mat-form-field>

            <ng-select
              [items]="tipos"
              bindLabel="label"
              bindValue="value"
              formControlName="tipos"
              placeholder="Tipos"
              notFoundText="Sin resultados"
              style="flex: 1; min-width: 0"
              [multiple]="true"
              [closeOnSelect]="false"
              appendTo="body"
            ></ng-select>
          </section>
        </app-content-card>

        <!-- Ubicación -->
        <app-content-card title="Ubicación" icon="location_on">
          <div class="map-container-2">
            <app-mapa-facil
              class="mapita"
              [setMarker]="true"
              [inputDireccion]="true"
              (inicializado)="iniciarMapa()"
            ></app-mapa-facil>
          </div>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="dialogRef.close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
